import {
  Building2Icon,
  BuildingIcon,
  GaugeIcon,
  HouseIcon,
  HousePlusIcon,
  JapaneseYenIcon,
  MegaphoneIcon,
  PackageIcon,
  UsersIcon,
  WrenchIcon,
} from "@/components/ui"

export const ICON = {
  ACCOUNT: UsersIcon,
  BRANCH: Building2Icon,
  CONTINUING_PROPERTY: HousePlusIcon,
  DASHBOARD: GaugeIcon,
  INSURANCE: JapaneseYenIcon,
  NEWS: MegaphoneIcon,
  PRODUCT: PackageIcon,
  PROPERTY: HouseIcon,
  SETTING: WrenchIcon,
  VENDOR: BuildingIcon,
}
